import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0dd066e&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a0dd066e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dd066e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteBlogArticleHeader: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/blog/article/header.vue').default,SiteBlogArticleBody: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/blog/article/body.vue').default,SiteBlogArticleAside: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/blog/article/aside.vue').default,SiteBlogArticleRelated: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/blog/article/related.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/feefo.vue').default})
